import { Writable } from 'stream';
import { ILog } from '../types';

export const createLoggerTransport = (logger: ILog, level: keyof ILog = 'debug') =>
  new Writable({
    objectMode: true,
    write(chunk, _encoding, callback) {
      logger[level](chunk.toString());
      callback();
    },
  });
